// Composite `${type}#${subtype}` format matching what the Plaid flow
// stores in LinkedAccount.bank_account_type. Keeps a single shape in
// the DB column across both link methods.
export enum BankAccountType {
  Checking = 'depository#checking',
  Savings = 'depository#savings',
}

export enum LinkMethod {
  Plaid = 'plaid',
  Manual = 'manual',
}

export interface ManualLinkFormValues {
  routing_number: string;
  account_number: string;
  bank_account_type: BankAccountType;
}

/**
 * Validates a US ABA routing number via mod-10 checksum.
 * Mirrors `validateRoutingNumber` in the bank-utils common package.
 */
export function isValidRoutingNumber(rn: string): boolean {
  if (!/^\d{9}$/.test(rn)) return false;
  const d = rn.split('').map(Number);
  const checksum =
    3 * (d[0] + d[3] + d[6]) +
    7 * (d[1] + d[4] + d[7]) +
    1 * (d[2] + d[5] + d[8]);
  return checksum % 10 === 0;
}
